module.exports = __webpack_public_path__ + "static/media/Castform_gaussian2.e12f2f46.png";